module.exports = __webpack_public_path__ + "img/startimes.ec0ac4de.png";